export default __webpack_public_path__ + "static/media/postgresql.29aef667.svg";